module.exports = __webpack_public_path__ + "img/s.41de089.png";